var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelListOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.141,
    height: 14.348,
    viewBox: "0 0 16.141 14.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.071,3.222l-6.124,5.4a1.3,1.3,0,0,1-.153.094V13.9a.448.448,0,0,0,.448.448H6.424l-1.043-2.04L8.3,10.514,6.612,7.173l4.149,3.833L7.844,12.8l1.119,1.548H13.9a.448.448,0,0,0,.448-.448V8.718a1.308,1.308,0,0,1-.147-.09Zm7.922,3.4L14.348,5.169V1.345A.448.448,0,0,0,13.9.9H12.106a.448.448,0,0,0-.448.448V2.794L8.82.289a1.117,1.117,0,0,0-1.5,0L.149,6.621a.449.449,0,0,0-.034.633l.6.668a.448.448,0,0,0,.633.034L7.774,2.288a.449.449,0,0,1,.593,0l6.426,5.668a.449.449,0,0,0,.633-.034l.6-.668A.448.448,0,0,0,15.993,6.621Z",
    transform: "translate(0)",
    fill: "#fd6c50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelListOrange);
export default __webpack_public_path__ + "static/media/del_list_orange.b3910e632ae2177b01bab0cc32f8877e.svg";
export { ForwardRef as ReactComponent };